import React from 'react';
import { connect } from 'react-redux';
import ApplicationLoading from '../presentational/ApplicationLoading';


const ApplicationLoadingWrapper = ({ isApplicationLoading = false, ...props }) => (
    isApplicationLoading && <ApplicationLoading {...props} />
);

const mapStateToProps = ({ isApplicationLoading }) => ({
    isApplicationLoading
});

export default connect(mapStateToProps)(ApplicationLoadingWrapper);


// WEBPACK FOOTER //
// ./src/components/loading/container/ApplicationLoading.js